export default "__VITE_ASSET__7751bd66__"